import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { app_testComponent } from './app.test.component';

import { Utilities_ShellService } from './Utilities.shell.service';
import { Totes_ShellService } from './Totes.shell.service';
import { ProgrammableLogicController_ShellService } from './ProgrammableLogicController.shell.service';

@Injectable({ providedIn: 'root' })
export class app_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
    public Utilities: Utilities_ShellService,
    public Totes: Totes_ShellService,
    public ProgrammableLogicController: ProgrammableLogicController_ShellService,
  ) {
    super(dialog, toastr);
  }

  public app: app_ShellService = this;

  public opentest(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'test',
        referenceName: 'test',
        component: app_testComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public opentestDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      app_testComponent,
      'test',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'test') {
      const title = 'test';
      const component = app_testComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.Utilities.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.Totes.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.ProgrammableLogicController.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
